export const SAVED_FILTER_NAME_MAX_LENGTH = 50;

export const SAVED_FILTER_MODULES = {
  FIND_NEW_CONTACTS: 'find-new-contacts',
};

export const FIND_NEW_CONTACTS_SUB_MODULES = {
  CONSUMERS: 'consumers',
  BUSINESSES: 'businesses',
};
